<script setup lang="ts">
    const router = useRouter();
    const { count } = useCart();
    const sidebarController = useModal();
    const { ensureShopwareSession } = useEnsureShopwareSession();
    const { urlSegment } = useLanguage();
    const { refreshCart } = useCart();

    const { data: story } = useConfig();

    onMounted(async () => {
        await handlePostLogin();
        refreshCart();
    });

    const openSideCart = async () => {
        await ensureShopwareSession({ reason: 'header-cart-open' });
        sidebarController.open();
    };

    const openSideCartWithFocus = async () => {
        await ensureShopwareSession({ reason: 'header-cart-open-focus' });
        sidebarController.openWithFocus();
    };
</script>

<template>
    <div
        v-if="
            router.currentRoute.value.fullPath != `/${urlSegment}/shop/checkout` &&
            !story?.content.header?.[0]?.hideCart
        "
        class="cart"
    >
        <button
            id="cart-button"
            class="cart-button"
            :aria-label="count + ' ' + $t('cart.itemsInCart') + ', ' + $t('cart.viewCart')"
            data-testid="cart-button"
            @click="openSideCart"
            @keydown.space="openSideCartWithFocus"
        >
            <!-- Icon -->
            <img
                src="~/assets/icons/shopping-cart-white.svg"
                alt="Einkaufswagen Icon"
                aria-hidden="true"
            />

            <span
                v-if="count > 0"
                class="product-count"
                aria-hidden="true"
            >
                {{ count }}
            </span>
            <span class="sr-only">{{ count }} {{ $t('cart.itemsInCart') }}, {{ $t('cart.viewCart') }}</span>
        </button>
    </div>

    <CheckoutSideCart :controller="sidebarController" />
</template>

<style scoped>
    @import '~/assets/scss/navigation/header-cart.scss';
</style>
